import React, { Component } from 'react'
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBDropdown,
    MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBIcon, MDBFormInline
} from "mdbreact";
import { Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip,Avatar } from 'antd';
import { URL } from '../api';
import sdd from '../img/9bHjJNbY.jpg';


export default class Header extends Component {

    state = {
        isOpen: false,
        nameuser: '',
        admin_type: '',
        Username: '',
    };

    toggleCollapse = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }



    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') !== "") {
          this.setState({ nameuser: localStorage.getItem('nameuser') })
          this.setState({ admin_type: localStorage.getItem('admin_type') })
        } else {
    
            this.setState({ admin_type: 'public' })
        }
      }


      logout() {
      //   localStorage.removeItem(('admin_type'))
       //  localStorage.removeItem(('nameuser'))
        localStorage.clear();
    
        setTimeout(() => {
          window.location.href = 'https://edu.kpru.ac.th/conference/'
        }, 1000);
       // this.setState({ admin_type: 'public' }
        message.success("ออกจากระบบแล้ว")
      }





    render() {



        let logout
        logout = (
          <>
            <MDBNavItem>
              <MDBNavLink to="/main"> {this.state.nameuser}</MDBNavLink>
    
            </MDBNavItem>
           
            <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/conference">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
    
        let superadmin
        superadmin = (
          <>
           <MDBNavItem >
                 <MDBNavLink to="/superadmincheckpayment"><MDBIcon icon="file-alt" /> ตรวจสอบการชำระเงิน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadmin"><MDBIcon icon="file-alt" /> บทความเข้าใหม่</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadmininside"><MDBIcon far icon="chart-bar" />สัดส่วนบทความ</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadminstatus"><MDBIcon icon="home" /> สถานะบทความ</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadminlistregister"><MDBIcon icon="home" /> ข้อมูลผู้ลงทะเบียน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadminaddress"><MDBIcon icon="home" /> ที่อยู่</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadmincertificate"><MDBIcon icon="home" /> จัดการเกียรติบัตร</MDBNavLink>
            </MDBNavItem>
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon icon="home" />  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
        

        let adminfaculty
        adminfaculty = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/adminfaculty"><MDBIcon icon="home" /> สถานะบทความคณะ</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/adminfacultyproportion"><MDBIcon icon="home" /> สัดส่วนบทความ</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadmincertificate"><MDBIcon icon="home" /> จัดการเกียรติบัตร</MDBNavLink>
            </MDBNavItem>
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )


        let expert
        expert = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/expert"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/expert"><MDBIcon icon="home" /> สัดส่วนบทความvvvvvv</MDBNavLink>
            </MDBNavItem> */}
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )

        let expertbn
        expertbn = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/expertbn"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/expert"><MDBIcon icon="home" /> สัดส่วนบทความvvvvvv</MDBNavLink>
            </MDBNavItem> */}
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
    


        let publics
        publics = (
          <>
           <MDBNavItem  >
              <MDBNavLink to="/">   หน้าหลัก </MDBNavLink>
            </MDBNavItem>
           <MDBNavItem  >
              <MDBNavLink to="/main">   เข้าสู่ระบบ </MDBNavLink>
            </MDBNavItem>
           
{/*             
            <MDBNavItem  >
              <MDBNavLink to="/Register">  ลงทะเบียน </MDBNavLink>
            </MDBNavItem> */}
             <MDBNavItem  >
              <MDBNavLink to="/Report">  ตรวจสอบการลงทะเบียน </MDBNavLink>
            </MDBNavItem>
          </>
        )


        let user
        user = (
          <>
           <MDBNavItem  >
              <MDBNavLink to="/Homeuser">   หน้าหลัก </MDBNavLink>
            </MDBNavItem>
           
            <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          
    
    
          </>
        )

        return (
            <>
             
                <MDBNavbar color="indigo" dark expand="md">
                    <MDBNavbarBrand>
                   <strong className="white-text"><Avatar src={sdd} /> NCE CONFERENCE</strong>
                    </MDBNavbarBrand>
                    <MDBNavbarToggler onClick={this.toggleCollapse} />
                    <MDBCollapse id="navbarCollapse3" onCollapse={(e)=>{console.log(e)}} isOpen={this.state.isOpen}  navbar>
                        <MDBNavbarNav left>

                            {/* <MDBNavItem >
                                <MDBNavLink to="/"><MDBIcon icon="home" /> Home</MDBNavLink>
                            </MDBNavItem> */}

                       

                          {this.state.admin_type !== null ? <>
                            
                           {this.state.admin_type === '2' ? <>
                            {superadmin}
                            </> : null}

                            {this.state.admin_type === '3' ? <>
                            {expert}
                            </> : null}

                            {this.state.admin_type === '5' ? <>
                            {expertbn}
                            </> : null}

                            {this.state.admin_type === '4' ? <>
                            {adminfaculty}
                            </> : null}  

                            {this.state.admin_type === '1' ? <>
                            {user}
                            </> : null}  

                            </> : <>{publics}</>}  

                        </MDBNavbarNav>
                        <MDBNavbarNav right>
                            <MDBNavItem>
                                <MDBFormInline waves>
                                    <div className="md-form my-0">
                                        <input className="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
                                    </div>
                                </MDBFormInline>
                            </MDBNavItem>
                        </MDBNavbarNav>
                        </MDBCollapse>
                </MDBNavbar>
               

            </>
        )
    }
}

